import { format } from 'date-fns';

const TZ_STORAGE_KEY = 'display_timezone';

const parseOffsetMinutes = (tz: string | null | undefined): number => {
  const v = (tz || '').trim();
  if (!v || /^Z$/i.test(v) || /^UTC$/i.test(v)) return 0;
  const m1 = v.match(/^([+-])(\d{2}):(\d{2})$/);
  if (m1) {
    const sign = m1[1] === '-' ? -1 : 1;
    const hh = parseInt(m1[2], 10);
    const mm = parseInt(m1[3], 10);
    return sign * (hh * 60 + mm);
  }
  const m2 = v.match(/^([+-])(\d{2})$/);
  if (m2) {
    const sign = m2[1] === '-' ? -1 : 1;
    const hh = parseInt(m2[2], 10);
    return sign * (hh * 60);
  }
  const m3 = v.match(/^UTC([+-])(\d{1,2})(?::(\d{2}))?$/);
  if (m3) {
    const sign = m3[1] === '-' ? -1 : 1;
    const hh = parseInt(m3[2], 10);
    const mm = parseInt(m3[3] || '0', 10);
    return sign * (hh * 60 + mm);
  }
  return 0;
};

const getTzOffsetMinutes = (): number => {
  const tz = localStorage.getItem(TZ_STORAGE_KEY) || '+08:00';
  return parseOffsetMinutes(tz);
};

export const formatInDisplayTz = (isoUtc: string, pattern: string): string => {
  if (!isoUtc) return '';
  const d = new Date(isoUtc);
  if (Number.isNaN(d.getTime())) return '';
  const off = getTzOffsetMinutes();
  const local = new Date(d.getTime() + off * 60_000);
  // 使用 UTC 方法读取已偏移的时间，避免二次时区转换
  const formatted = pattern
    .replace(/yyyy/g, String(local.getUTCFullYear()))
    .replace(/MM/g, String(local.getUTCMonth() + 1).padStart(2, '0'))
    .replace(/dd/g, String(local.getUTCDate()).padStart(2, '0'))
    .replace(/HH/g, String(local.getUTCHours()).padStart(2, '0'))
    .replace(/mm/g, String(local.getUTCMinutes()).padStart(2, '0'))
    .replace(/ss/g, String(local.getUTCSeconds()).padStart(2, '0'));
  return formatted;
};

export const toDatetimeLocal = (isoUtc: string): string => {
  if (!isoUtc) return '';
  const d = new Date(isoUtc);
  if (Number.isNaN(d.getTime())) return '';
  const off = getTzOffsetMinutes();
  const local = new Date(d.getTime() + off * 60_000);
  // 使用 UTC 方法读取已偏移的时间，避免二次时区转换
  const y = local.getUTCFullYear();
  const m = String(local.getUTCMonth() + 1).padStart(2, '0');
  const day = String(local.getUTCDate()).padStart(2, '0');
  const hh = String(local.getUTCHours()).padStart(2, '0');
  const mm = String(local.getUTCMinutes()).padStart(2, '0');
  return `${y}-${m}-${day}T${hh}:${mm}`;
};

export const fromDatetimeLocal = (localStr: string): string => {
  const tz = localStorage.getItem(TZ_STORAGE_KEY) || '+08:00';
  const suffix = /^([+-]\d{2}:\d{2})$/.test(tz)
    ? tz
    : /^([+-]\d{2})$/.test(tz)
    ? `${tz}:00`
    : /^UTC[+-]\d{1,2}(:\d{2})?$/.test(tz)
    ? (() => {
        const m = tz.match(/^UTC([+-])(\d{1,2})(?::(\d{2}))?$/)!;
        const sign = m[1];
        const hh = m[2].padStart(2, '0');
        const mm = (m[3] || '00').padStart(2, '0');
        return `${sign}${hh}:${mm}`;
      })()
    : 'Z';
  const candidate = suffix === 'Z' ? `${localStr}Z` : `${localStr}${suffix}`;
  const d = new Date(candidate);
  return d.toISOString();
};
